import { ActivatedRoute } from '@angular/router';
import { UtilsService } from './../../../services/utils.service';
import { ErrorResponse } from './../../../models/error.model';
import { OfficesService } from './../../../services/offices.service';
import { Office } from './../../../models/office.model';
import { Component, OnInit } from '@angular/core';
import { ID } from '../../../models/ID.model';

@Component({
  selector: 'app-office-details',
  templateUrl: './office-details.component.html',
  styleUrls: ['./office-details.component.scss']
})
export class OfficeDetailsComponent implements OnInit {

    office?: Office;

    constructor(
        private officesService: OfficesService,
        private utilsService: UtilsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.getOffice(params.id);
            }
        });
    }

    getOffice(id: ID) {
        this.officesService.getOfficeById(id).subscribe(office => {
            this.office = office;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener detalles de la oficina', error.error?.descripcion));
    }

}
